import { pages } from './pages'
import { main } from '@/lang/fr/main.ts'
import { errors } from '@/lang/fr/errors.ts'

export default {
  main,
  pages,
  errors,
}
